import { render, staticRenderFns } from "./sch_xunfang.vue?vue&type=template&id=240b48e0&scoped=true"
import script from "./sch_xunfang.vue?vue&type=script&lang=js"
export * from "./sch_xunfang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240b48e0",
  null
  
)

export default component.exports